<h2 mat-dialog-title>Busqueda Producto</h2>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col s12 m12 l12" style="text-align: center">
      <p style="color: red; font-size: 16px; font-weight: bold">
        Por favor seleccione el producto que desea ingresar
      </p>
    </div>
  </div>

  <mat-nav-list>
    <h3 mat-subheader>LISTADO DE PRODUCTOS</h3>
    <mat-list-item
      *ngFor="let producto of productosLista"
      (click)="productoSeleccionado(producto)"
    >
      <mat-icon mat-list-icon>beenhere</mat-icon>
      <h3 class="titulo-item" mat-line>
        <span style="color: grey; font-weight: bold">Producto:</span>
        {{ producto.idExProducto }} -- {{ producto.descripcion }}
      </h3>
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-nav-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="productoSeleccionado('')">
    Cerrar
  </button>
</mat-dialog-actions>
